import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import tassAxios from '@/apis/tass-api/axios';

type AddUserToOrganizationRequest = {
  userId: string;
  organizationId: string;
  products: string[];
};

const addUserToOrganization = async ({ organizationId, userId, products }: AddUserToOrganizationRequest) => {
  await tassAxios.patch('/api/Organization/AddUserToOrganization', products, {
    params: { organizationId, userId },
  });
};

export const useAddUserToOrganization = (organizationId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addUserToOrganization,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription', organizationId] });
      queryClient.invalidateQueries({ queryKey: ['product-accesses', organizationId] });
    },
    onError: () => toast.error('An error occurred while adding the user to the organization'),
  });
};
